import React from "react";
import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import { getMarker } from "../../../utilities";
import styleConstants from "../../../styleConstants";

const styles = {
  bar: {
    width: 22,
    height: 11
  },
  bars: {
    display: "flex"
  },
  costPrivate: {
    backgroundColor: styleConstants.categoryColors.sectorColors["Private"]
  },
  costPublic: {
    backgroundColor: styleConstants.categoryColors.sectorColors["Public"]
  },
  label: {
    marginLeft: "0.5rem"
  },
  line: {
    margin: "0 -2px",
    width: 25,
    height: 3,
    backgroundColor: "black",
  },
  series: {
    margin: "0.25rem 0",
    display: "flex",
    alignItems: "center"
  },
  users: {
    width: 44,
    display: "flex",
    alignItems: "center"
  }
};

const CostVsUsersLegend = props => (
  <div>
    <div className={props.classes.series}>
      <div className={props.classes.bars}>
        <div
          className={classNames(props.classes.bar, props.classes.costPublic)}
        />
        <div
          className={classNames(props.classes.bar, props.classes.costPrivate)}
        />
      </div>
      <div className={props.classes.label}>Cost</div>
    </div>

    <div className={props.classes.series}>
      <div className={props.classes.users}>
        <div
          dangerouslySetInnerHTML={{
            __html: getMarker(
              styleConstants.categoryColors.sectorColors["Public"]
            )
          }}
        />
        <div className={props.classes.line} />
        <div
          dangerouslySetInnerHTML={{
            __html: getMarker(
              styleConstants.categoryColors.sectorColors["Private"]
            )
          }}
        />
      </div>
      <div className={props.classes.label}>Users</div>
    </div>
  </div>
);

export default withStyles(styles)(CostVsUsersLegend);
